<template>
  <div class="columns">
    <div class="column is-three-quarters solicitudes-table">
      <admin-section-header icon="account-multiple" title="Usuarios" />
      <div class="field has-addons">
        <div class="control">
          <button
            v-if="userRole == 'corporative_director'"
            @click="$router.push({ name: 'admin.users.new' })"
            class="button is-primary is-medium"
          >
            {{ $t('Añadir') }}
          </button>
        </div>
        <div class="control">
          <b-input v-model="searchEmailString" />
        </div>
      </div>

      <b-tabs v-model="activeTab">
        <b-tab-item label="Mi Red de Franquiciados">
          <b-table
            :loading="isLoading"
            :paginated="true"
            :per-page="10"
            :striped="true"
            :hoverable="true"
            default-sort="name"
            :data="filteredUsers(['partner', 'subpartner'])"
          >
            <template slot-scope="props">
              <b-table-column>
                <b-icon
                  v-if="props.row.user_id"
                  icon="account-check"
                  type="is-primary"
                  custom-size="default"
              /></b-table-column>
              <b-table-column
                :sortable="true"
                :label="$t('Email')"
                field="email"
                >{{ props.row.email }}</b-table-column
              >
              <b-table-column :label="$t('Tipo')">{{
                props.row.attributes.main_rol
              }}</b-table-column>
              <b-table-column label=" " v-if="userRole == 'corporative_director'">
                <div class="buttons is-right">
                  <button
                    @click="goToUpdateUser(props.row)"
                    class="button is-small is-primary"
                    type="button"
                  >
                    <b-icon icon="eye" custom-size="default" />
                  </button>
                  <button
                    :disabled="!props.row.user_id"
                    @click="callPostResetUserPassword(props.row)"
                    class="button is-small is-info"
                    type="button"
                  >
                    <b-icon icon="lock" custom-size="default" />
                  </button>
                  <button
                    @click="removeUser(props.row)"
                    class="button is-small is-danger"
                    type="button"
                  >
                    <b-icon icon="trash-can" custom-size="default" />
                  </button>
                </div>
              </b-table-column>
            </template>

            <section class="section" slot="empty">
              <div class="content has-text-grey has-text-centered">
                <template v-if="isLoading">
                  <p>
                    <b-icon icon="dots-horizontal" size="is-large" />
                  </p>
                  <p>{{ $t('Cargando') }}...</p>
                </template>
                <template v-else>
                  <p>
                    <b-icon icon="emoticon-sad" size="is-large" />
                  </p>
                  <p>{{ $t('No hay resultados') }}&hellip;</p>
                </template>
              </div>
            </section>
          </b-table>
        </b-tab-item>
        <b-tab-item label="Mi Red de Compañías">
          <b-table
            :loading="isLoading"
            :paginated="true"
            :per-page="10"
            :striped="true"
            :hoverable="true"
            default-sort="name"
            :data="filteredUsers(['client'])"
          >
            <template slot-scope="props">
              <b-table-column>
                <b-icon
                  v-if="props.row.user_id"
                  icon="account-check"
                  type="is-primary"
                  custom-size="default"
              /></b-table-column>
              <b-table-column
                :sortable="true"
                :label="$t('Email')"
                field="email"
                >{{ props.row.email }}</b-table-column
              >
              <b-table-column :label="$t('Tipo')">{{
                props.row.attributes.main_rol
              }}</b-table-column>
              <b-table-column label=" ">
                <div class="buttons is-right">
                  <button
                    @click="goToUpdateUser(props.row)"
                    class="button is-small is-primary"
                    type="button"
                  >
                    <b-icon icon="eye" custom-size="default" />
                  </button>
                  <button
                    :disabled="!props.row.new_id"
                    @click="callPostResetUserPassword(props.row)"
                    class="button is-small is-info"
                    type="button"
                  >
                    <b-icon icon="lock" custom-size="default" />
                  </button>
                  <button
                    @click="removeUser(props.row)"
                    class="button is-small is-danger"
                    type="button"
                  >
                    <b-icon icon="trash-can" custom-size="default" />
                  </button>
                </div>
              </b-table-column>
            </template>

            <section class="section" slot="empty">
              <div class="content has-text-grey has-text-centered">
                <template v-if="isLoading">
                  <p>
                    <b-icon icon="dots-horizontal" size="is-large" />
                  </p>
                  <p>{{ $t('Cargando') }}...</p>
                </template>
                <template v-else>
                  <p>
                    <b-icon icon="emoticon-sad" size="is-large" />
                  </p>
                  <p>{{ $t('No hay resultados') }}&hellip;</p>
                </template>
              </div>
            </section>
          </b-table>
        </b-tab-item>
      </b-tabs>
    </div>
    <div class="column is-one-quarter twitter">
      <TwitterFeed profile="bancomundial" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Fetcher from '@/mixins/fetcher.js'
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import TwitterFeed from '@/components/admin/dasboard/TwitterFeed.vue'
export default {
  components: { AdminSectionHeader, TwitterFeed },
  name: 'AdminUsersList',
  mixins: [Fetcher],
  props: {},
  data() {
    return {
      isLoading: false,
      isNewUserModalActive: false,
      selectedRoles: [],
      searchEmailString: '',
      users: []
    }
  },
  computed: {
    existingUserRoles() {
      const uniqueRolesSet = new Set(this.users.map(user => user.rol))
      return [...uniqueRolesSet]
    },
    userRole() {
      return this.$store.getters['user/rol']
    }
  },
  methods: {
    ...mapActions('user', [
      'getAdminUsers',
      'deleteUser',
      'postResetUserPassword'
    ]),
    async callGetAdminUsers() {
      let self = this
      self.request(() =>
        self.getAdminUsers().then(function(response) {
          self.users = response.data
          self.isLoading = false
          const uniqueRolesSet = new Set(self.users.map(user => user.rol))
          self.selectedRoles = [...uniqueRolesSet]
        })
      )
    },
    filteredUsers(roles) {
      return this.users.filter(
        user =>
          roles.includes(user.rol) &&
          user.email.includes(this.searchEmailString)
      )
    },
    goToUpdateUser(user) {
      this.$router.push({
        name: 'admin.users.update',
        params: { id: user.new_id || user.email }
      })
    },
    removeUser(user) {
      let self = this
      self.$dialog.confirm({
        message: self.$t('¿Estás seguro? esta operación no se puede deshacer'),
        type: 'is-danger',
        onConfirm: function() {
          self.request(() =>
            self.deleteUser(user.new_id || user.email).then(function() {
              self.callGetAdminUsers()
            })
          )
        }
      })
    },
    callPostResetUserPassword(user) {
      let self = this
      self.request(() =>
        self.postResetUserPassword(user.new_id || user.email).then(function() {
          self.$toast.open({
            message: self.$t('Contraseña reseteada'),
            type: 'success'
          })
        })
      )
    }
  },

  mounted() {
    this.callGetAdminUsers()
  }
}
</script>

<style scoped></style>
